import * as React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Business } from '@mui/icons-material';

import { AvatarSetting, BrandColorPicker } from 'components';
import { useCompanyFormManager } from './company-form.hook';

interface CompanyFormProps {
  visibleSlug?: boolean;
  onSubmitting?: (loading: boolean) => void;
  next?: (data?: any) => void;
}

export const CompanyForm = React.forwardRef(
  ({ visibleSlug = false, onSubmitting = () => {}, next }: CompanyFormProps, ref) => {
    const [{ org, formManager, loading_submit }] = useCompanyFormManager({ next });

    React.useImperativeHandle(ref, () => ({ onSubmit: () => formManager.handleSubmit() }), []);
    React.useEffect(() => onSubmitting(loading_submit), [loading_submit]);

    return (
      <form onSubmit={formManager.handleSubmit} autoComplete="off">
        <Box paddingY={2}>
          <Grid container rowSpacing={3} columnSpacing={2}>
            <Grid item xs={12}>
              <Box marginBottom={1} display="flex" alignItems="center">
                <Typography variant="caption" color="textSecondary">
                  Customize your Cleancode® decal
                </Typography>
              </Box>

              <AvatarSetting
                avatarUrl={formManager.values.avatar ? URL.createObjectURL(formManager.values.avatar) : org?.logo?.url}
                isError={!!(formManager.errors.avatar && formManager.touched.avatar)}
                helperText={formManager.touched.avatar && formManager.errors.avatar ? formManager.errors.avatar : ''}
                placeholderImage={
                  <Business
                    sx={{
                      fontSize: 64,
                    }}
                  />
                }
                onSelectFile={(file) => formManager.setFieldValue('avatar', file)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Company name"
                variant="outlined"
                fullWidth
                value={formManager.values.name}
                onChange={formManager.handleChange('name')}
                error={!!(formManager.errors.name && formManager.touched.name)}
                helperText={formManager.touched.name ? formManager.errors.name : null}
              />
            </Grid>

            {visibleSlug && (
              <Grid item xs={12}>
                <TextField label="API Url Slug" variant="outlined" fullWidth value={formManager.values.slug} disabled />
              </Grid>
            )}

            <Grid item xs={12}>
              <Box marginBottom={1} display="flex" alignItems="center">
                <Typography variant="caption">Add at least one brand color</Typography>
              </Box>

              <Box display="flex" alignItems="center">
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Primary Color
                  </Typography>
                  <Box
                    sx={{
                      position: 'relative',
                      zIndex: 2000,
                    }}
                  >
                    <BrandColorPicker
                      primaryColor={formManager.values.primary_brand_color}
                      onChangePrimaryColor={(value) => formManager.setFieldValue('primary_brand_color', value)}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    marginLeft: 2,
                  }}
                >
                  <Typography variant="caption" color="textSecondary">
                    Secondary Color
                  </Typography>
                  <Box
                    sx={{
                      position: 'relative',
                      zIndex: 2000,
                    }}
                  >
                    <BrandColorPicker
                      primaryColor={formManager.values.secondary_brand_color}
                      onChangePrimaryColor={(value) => formManager.setFieldValue('secondary_brand_color', value)}
                    />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </form>
    );
  },
);
